import moment from 'moment'
export default {
    platForm () {
        var form = {}
        var ua = window.navigator.userAgent
        form.isIOS = /\b(iPad|iPhone|iPod)\b.*? OS ([\d_]+)/.test(ua)
        form.isIOS9 = /\b(iPad|iPhone|iPod)\b.*? OS ([\d_]+)/.test(ua) && /OS 9/.test(ua)
        form.isIOS10 = /\b(iPad|iPhone|iPod)\b.*? OS ([\d_]+)/.test(ua) && /OS 10/.test(ua)
        form.isAndroid = /\bAndroid([^;]+)/.test(ua)
        form.isWx = /MicroMessenger/.test(ua)
        form.isWeibo = /\bWeibo|__weibo__\d/.test(ua)
        form.isQzone = /Qzone\//.test(ua)
        form.isQQ = /QQ\//.test(ua)
        form.isOpera = ua.indexOf('Opera') > -1 // 判断是否Opera浏览器
        form.isIE = ua.indexOf('compatible') > -1 && ua.indexOf('MSIE') > -1 && !form.isOpera // 判断是否IE浏览器
        form.isEdge = ua.indexOf('Edge') > -1 // 判断是否IE的Edge浏览器
        form.isFF = ua.indexOf('Firefox') > -1 // 判断是否Firefox浏览器
        form.isSafari = ua.indexOf('Safari') > -1 && ua.indexOf('Chrome') === -1 // 判断是否Safari浏览器
        form.isChrome = ua.indexOf('Chrome') > -1 && ua.indexOf('Safari') > -1 // 判断Chrome浏览器
        return form
    },
    searchParam () {
        var params = window.location.search.substring(1).split('&')
        var param = {}
        var temp
        for (var index in params) {
            temp = params[index].split('=')
            if (temp[0]) {
                param[temp[0]] = temp[1]
            }
        }
        return param
    },
    newCalendar (setDate) {
        moment.locale('zh-cn', {
            weekdaysMin: ['日', '一', '二', '三', '四', '五', '六']
        })
        moment.locale('zh-cn')
        var daysArr = [
            [],
            [],
            [],
            [],
            [],
            []
        ] // 6*7的日历数组
        var weekdays = moment.weekdaysMin() // 取出星期
        var nowDay = moment().format('YYYY-MM-DD') // 当天
        var nowDate = moment(setDate) // 解析时间 ( 指定月份 )
        var frontDate = moment(setDate).subtract(1, 'month') // 解析时间 ( 上月 )
        var afterDate = moment(setDate).add(1, 'month') // 解析时间 ( 下月 )
        var currentMonthDays = nowDate.daysInMonth() // 当前指定月份天数
        var currentWeekday = nowDate.date(1).weekday() // 当前指定月份1日为星期几
        var nowMonth = nowDate.format('YYYY-MM') // 当前指定月份
        var lastMonthDays = frontDate.daysInMonth() // 上月天数
        var frontMonth = frontDate.format('YYYY-MM') // 上月月份
        var afterMonth = afterDate.format('YYYY-MM') // 下月月份
        function getDay (day) {
            var ret = {}
            if (day <= lastMonthDays) {
                ret.day = day
                ret.date = frontMonth + '-' + ('00' + day).slice(-2)
                ret.month = '' // 非当前月
            } else if (day <= (lastMonthDays + currentMonthDays)) {
                ret.day = day - lastMonthDays
                ret.date = nowMonth + '-' + ('00' + ret.day).slice(-2)
                ret.month = 'current' // 当前月
                ret.nowDay = ret.date === nowDay // 是否当天
            } else {
                ret.day = day - (lastMonthDays + currentMonthDays)
                ret.date = afterMonth + '-' + ('00' + ret.day).slice(-2)
                ret.month = '' // 非当前月
            }
            return ret
        }
        for (var i = 0; i < 7; i += 1) {
            var virtualDay = (lastMonthDays - currentWeekday + 1) + i
            for (var j = 0; j < 6; j += 1) {
                daysArr[j][i] = getDay(virtualDay + (j * 7))
            }
        }
        return {
            weekdays: weekdays,
            data: daysArr
        }
    },
    domain () {
        return location.hostname.replace(/^(([^.])+\.)/, '')
    },
    protocol () {
        return location.protocol.slice(0, -1) || 'http'
    }
}



// WEBPACK FOOTER //
// ./src/until/until.js